import{purry as e}from"./purry-DH9cw9sy.js";import{words as t}from"./words-dqKxdQm-.js";function n(...t){return e(r,t)}const r=e=>t(e).join(`-`).toLowerCase();export{n as toKebabCase};
//# sourceMappingURL=toKebabCase-DfXTesFY.js.map